"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientType = void 0;
// Note!: duplicated in @daytrip/logger
var ClientType;
(function (ClientType) {
    ClientType["Management"] = "management";
    ClientType["Website"] = "website";
    ClientType["iOS"] = "iOS";
    ClientType["DriverApp"] = "driver-app";
    ClientType["CustomerApp"] = "customer-app";
    ClientType["Cron"] = "cron";
    ClientType["Unknown"] = "unknown";
})(ClientType || (exports.ClientType = ClientType = {}));
//# sourceMappingURL=ClientType.js.map